<template>
  <div class="page">
    <div class="banner">
      <img class="banner" :src="goods.headImg || goods.headImgList[0].url" mode="widthFix" alt="">
    </div>
    <div class="content">
      <div class="top">
        <div class="top-left">
          <div class="yuan">
            价格：<span style="font-size: 8px">¥</span>
            <span>{{goods.oldPrice}}</span>
          </div>
          <div class="miao">
            秒杀价：
            <span v-if="goods.spikePrice > 0">{{goods.spikePrice}}元</span>
            <span v-else>免费</span>
          </div>
          <div class="miao" v-if="goods.boolPrePay == 'true'">
            秒杀定金：
            <span v-if="goods.preSpikePrice > 0">{{goods.preSpikePrice}}元</span>
            <span v-else>免费</span>
          </div>
        </div>
        <div class="top-right">
          <van-count-down :time="countDownTime">
            <template #default="timeData">
              <div class="countdown-content">
                <span class="block">{{ timeData.days }}</span>
                <span class="space">天</span>
                <span class="block">{{ timeData.hours }}</span>
                <span class="space">时</span>
                <span class="block">{{ timeData.minutes }}</span>
                <span class="space">分</span>
                <span class="block">{{ timeData.seconds }}</span>
                <span class="space">秒</span>
              </div>
            </template>
          </van-count-down>
        </div>
      </div>
      <div class="bottom">
        <div class="bottom-left">
          <div class="title">{{goods.goodName}}</div>
          <!-- <div class="line"></div>
          <p>{{goods.goodName}}</p> -->
        </div>
        <div class="bottom-right">
          <img src="https://img3.quanyou.com.cn/joy/group1/M00/16/58/rB4ChWMgHPGAEzEKAAAGbYZ_WHc800.png" />
          <div>分享</div>
        </div>
      </div>
    </div>
    <template v-if="goods.goodsDetails && goods.goodsDetails.length" >
      <img class="img-goods" :src="item" alt="" v-for="item in goods.goodsDetails" :key="item" mode="widthFix"/>
    </template>
    <template v-else-if="goods.detailsImg && goods.detailsImg.length" >
      <img class="img-goods" :src="item.url" alt="" v-for="(item,index) in goods.detailsImg" :key="index" mode="widthFix"/>
    </template>
    <img v-else class="img-goods" src="https://img3.quanyou.com.cn/joy/group1/M00/19/20/rB4ChmNaMZSAfoLXAAGUF_1MjUY048.png"  mode="widthFix">
    
    <div class="botton-box">
      <div class="button" @click="back">{{goods.spikeState == 0 ?'立即秒杀' : '查看更多秒杀产品' }}</div>
    </div>
    <div style="height:80px;"></div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  components: {
    // spikeTipsPop
  },
  computed:{
    goods(){
      return JSON.parse(this.$route.query.parames)
    },
    countDownTime() {
      return moment(this.goods.endTime).valueOf() - moment().valueOf();
    },
  },
  data() {
    return {
      statusBarHeight: 0,
      isSpikeTips: true
    }
  },
  methods: {
    back() {
      if (this.goods.spikeState != 0) {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .page {
    .banner {
      width 100%
      height auto
    }
    .content {
      width: 375px;
      height: 200px;
      padding: 10px 11px;
      box-sizing: border-box;
      background: url('https://img3.quanyou.com.cn/joy/group1/M00/16/56/rB4ChmMgE6iAHlm-AAFMvc79kko207.png');
      background-size: 100% 100%;
      .top {
        display: flex;
        justify-content: space-between;
        .top-left {
          font-size: 10px;
          color: #fff;
          .yuan {
            span {
              text-decoration:line-through; 
              font-size: 15px;
            }
          }
          .miao {
            span {
              font-size: 18px;
              font-weight: bold;
            }
          }
        }
        .top-right {
          margin-top: 30px;
          .countdown-content {
            font-size: 12px;
            .block {
              display: inline-block;
              text-align: center;
              line-height:  20px;
              width: 18px;
              height: 20px;
              color: #EA274E;
              background: #FFFFFF;
              border-radius: 4px;
            }
            .space {
              color: #fff;
              margin: 0 2px;
            }
          }
        }
      }
      .bottom {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 21px 15px 14px 26px;
        background: #FFFFFF;
        border-radius: 10px;
        margin-top: 13px;
        .bottom-left {
          .title {
            width: 258px;
            color: #222223;
            font-size: 22px;
            font-weight: 500;
          }
          .line {
            width: 258px;
            border: 1px solid #B3B5BD;
            margin: 7px 0;
          }
          p {
            width: 258px;
            font-size: 15px;
            color: #B3B5BD;
          }
        }
        .bottom-right {
          position: relative;
          font-size: 10px;
          color: #88888C;
          // margin: 15px 0 0 42px;
          img {
            width: 20px;
            height: 20px;
          }
          div {
            text-align: center;
          }
          .share {
            position: absolute;
            top: 5px;
            right: -5px;
            opacity: 0;
          }
        }
      }
    }
    .swiper-box {
      width: 100%;
      height: 175px;
      background: pink;
      .swiper {
        width: 100%;
        height: 175px;
      }
    }
    .img-goods {
      width 100%
      height auto
    }
    .botton-box {
      position: fixed;
      bottom: 10px;
      width: 100%;
      padding: 10px;
      box-sizing: border-box;
      .button {
        height: 44px;
        width: 100%;
        text-align: center;
        line-height:  44px;
        font-size: 15px;
        color: #fff;
        border-radius: 5px;
        background: linear-gradient(0deg, #FEA108 0%, #FF7D29 100%);
      }
    }
    
  }
  
</style> 